import "./About.css";
import { Helmet } from "react-helmet";

const About = () => {
  const progressData = [
    { name: "Renovation", percentage: 25 },
    { name: "Functional Spaces", percentage: 50 },
    { name: "Architecture", percentage: 75 },
  ];
  return (
    <>
      {/* -------container-1----------- */}
      <Helmet>
        <title>Interior Design Services - About Us | interior</title>
        <meta
          name="description"
          content="Learn more about our interior design services. We specialize in creating personalized, stunning spaces for both residential and commercial projects."
        />
        <meta
          name="keywords"
          content="interior design, home decor, commercial design, custom design solutions, professional interior design services"
        />
      </Helmet>
      <div className="about-bg">
        <div className="container">
          <div className="row">
            <h1 className="aboutus-heading">About us</h1>
            <p className="text-center text-white">
              Discover Our Passion for Creating Timeless and Innovative Designs
            </p>
          </div>
        </div>
      </div>
      {/* *****************container-2************************ */}
      <div className="container mt-5 mb-5">
        <div className="row">
          {/* Image Section */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 image-fader mb-2">
            <div>
              <img
                src="/images/about1.png"
                className="img-fluid"
                alt="About 1"
              />
              <img
                src="/images/about2.png"
                className="img-fluid"
                alt="About 2"
              />
              <img
                src="/images/about3.png"
                className="img-fluid"
                alt="About 3"
              />
              <img
                src="/images/about4.png"
                className="img-fluid"
                alt="About 4"
              />
            </div>
          </div>

          {/* Vision Section */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 vision ms-lg-3">
            {" "}
            {/* Added margin here */}
            <h5 className="text-center mt-4">Vision</h5>
            <p className="ps-5 mt-4 mb-5">
              Our vision is to be a global leader in the interior design
              industry, renowned for our creativity, innovation, and exceptional
              service. We aspire to continuously push the boundaries of design,
              embracing new trends and technologies to create spaces that
              inspire and delight. At Interior MNO , we are committed to making the
              world a more beautiful place, one room at a time.
            </p>
            {progressData.map((progress, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                {/* Progress name on the left */}
                <span
                  style={{
                    marginRight: "10px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {progress.name}
                </span>

                {/* Progress bar */}
                <div
                  className="progress"
                  style={{
                    height: "1px",
                    width: "100%",
                    flex: 1,
                    margin: "0 10px",
                  }}
                >
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${progress.percentage}%` }}
                    aria-valuenow={progress.percentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>

                {/* Percentage on the right */}
                <span style={{ marginLeft: "10px" }}>
                  {progress.percentage}%
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* ----------container 3--------------- */}
      <div className="about-container">
        <div className="container mt-4 ">
          <div className="row ">
            <h2 className="text-center mt-5 mb-5 fs-5 fs-bold">
              Discover Your Passion
            </h2>
            <div className="col-xl-6 mt-4">
              <div>
                <img
                  src="/images/about1.png"
                  className="img-fluid"
                  alt="About 1"
                />
              </div>
            </div>
            <div className="col-xl-6">
              <div>
                <h3 className="text-center mt-5 fs-1">Our Design Philosophy</h3>
                <p className="first-text lh-lg">
                  At mno interior, we believe that exceptional design should
                  seamlessly blend aesthetics, functionality, and
                  sustainability. Our approach is rooted in a profound
                  understanding of our clients’ needs and the unique context of
                  each project. We collaborate closely with our clients
                  throughout the entire design process, ensuring that their
                  vision is brought to life in a way that is both beautiful and
                  practical. By integrating environmentally responsible
                  practices, we create spaces that are not only visually
                  stunning but also harmonious with the environment. Our
                  commitment to excellence drives us to deliver designs that are
                  timeless, innovative, and tailored to enhance the lives of
                  those who inhabit them.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6">
              <div>
                <h3 className="text-center mt-5 fs-1">
                  Our Passion for Interior Design
                </h3>
                <p className="first-text lh-lg">
                  At xyz interior , we believe that exceptional interior design goes
                  beyond aesthetics; it’s about creating spaces that inspire,
                  function seamlessly, and respect the environment. Our passion
                  lies in understanding the unique needs and desires of our
                  clients, ensuring that each project reflects their
                  individuality and enhances their daily lives. We immerse
                  ourselves in the latest design trends and sustainable
                  practices, constantly pushing the boundaries of what’s
                  possible. Our commitment to innovation and excellence allows
                  us to transform ordinary spaces into extraordinary
                  experiences, blending beauty with practicality in every
                  detail. With a keen eye for detail and a dedication to
                  quality, we strive to create interiors that are not only
                  visually stunning but also harmonious and functional. At
                  Interior ABC, we are driven by the belief that great design has
                  the power to improve lives, and we are dedicated to making
                  that vision a reality for each of our clients.
                </p>
              </div>
            </div>
            <div className="col-xl-6">
              <div mt-4>
                <img
                  src="/images/about3.png"
                  className="img-fluid"
                  alt="About 1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
